import { BannerButton } from "../Components";
import { ContactForm, ErrorPage, RequestForm } from "./";
import React, { useState } from "react";
import "@metricell/smarttoolscore/dist/module/Styles/metricell.css";

export type SmartSupportTabs = "support" | "request" | "error";

export const SmartSupport: React.FunctionComponent = (): React.ReactElement => {
    const [tab, setTab] = useState<SmartSupportTabs>(`support`);

    const handleSupportClick = (): void => {
        setTab(`support`);
    };

    const handleRequestClick = (): void => {
        setTab(`request`);
    };

    const showErrorPage = (): void => {
        setTab(`error`);
    };

    return (
        <div className={`smartsupport`}>
            <div className={`support-banner`}>
                <BannerButton
                    isActive={tab === `support`}
                    onClick={handleSupportClick}
                    title={`Contact Support`}
                />
                <BannerButton
                    isActive={tab === `request`}
                    onClick={handleRequestClick}
                    title={`Feature Request`}
                />
            </div>
            <div className={`support-contentouter`}>
                <div className={`scroll`}>
                    <div className={`support-contentinner`}>
                        {tab === `support` && (
                            <ContactForm
                                showErrorPageCallback={showErrorPage}
                            />
                        )}
                        {tab === `request` && (
                            <RequestForm
                                showErrorPageCallback={showErrorPage}
                            />
                        )}
                        {tab === `error` && <ErrorPage />}
                    </div>
                </div>
            </div>
        </div>
    );
};
